import qs from 'query-string';
import { isEmptyValue } from '../../../../utils/common';
import { CB_STATUS_FROM_ESIA, ESIA_USIS_MODAL_STEPS } from '../../containers/PassportUpload/constants';
import {
  setUsisCommonModalStep,
  toggleUsisCommonModal,
} from '../../containers/PassportUpload/actions';

const convertStringToCamelCase = (str) => str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());

export const checkUrlStatusAfterEsia = () => async (dispatch) => {
  const url = window.location.href.replace('/#', '');
  const { query } = qs.parseUrl(url);

  if (!isEmptyValue(query)) {
    const { status, error } = query;

    if (status === CB_STATUS_FROM_ESIA.ERROR && error) {
      dispatch(setUsisCommonModalStep(convertStringToCamelCase(error)));
      dispatch(toggleUsisCommonModal(true));
      return;
    }

    if (error === CB_STATUS_FROM_ESIA.ESIA_SERVER_ERROR) {
      dispatch(setUsisCommonModalStep(ESIA_USIS_MODAL_STEPS.esiaServerError));
      dispatch(toggleUsisCommonModal(true));
      return;
    }

    if (error === CB_STATUS_FROM_ESIA.REFUSE_PERMISSION_BY_USER) {
      dispatch(setUsisCommonModalStep(ESIA_USIS_MODAL_STEPS.refusePermissionByUser));
      dispatch(toggleUsisCommonModal(true));
      return;
    }

    if (status === CB_STATUS_FROM_ESIA.ISSUE_PERMISSION) {
      dispatch(setUsisCommonModalStep(ESIA_USIS_MODAL_STEPS.issuePermission));
      dispatch(toggleUsisCommonModal(true));
      return;
    }

    if (status === CB_STATUS_FROM_ESIA.SUCCESS) {
      dispatch(setUsisCommonModalStep(ESIA_USIS_MODAL_STEPS.issuePermission));
      dispatch(toggleUsisCommonModal(true));
      return;
    }
  }

  return undefined;
};
